import { CrudService } from './CrudService';
import { TrainingQueryParams } from '../params/TrainingQueryParams';
import { TrainingDto } from '../models/training/TrainingDto';
import { resources } from '../resources';

export class TrainingService extends CrudService<TrainingDto, TrainingQueryParams> {
  constructor() {
    super({
      query: resources.queryTrainings,
      get: resources.getTrainingById,
      create: resources.createTraining,
      update: resources.updateTraining,
      idKey: 'trainingId',
    });
  }
}
